import { Card, Table } from "antd";
import { Button } from "antd";
import React, { FC } from "react";

type OthersProps = {
  handleModalOpen: any;
  uploadedOtherFileList: any[];
  uploadedFileColumns: any[];
  claimData?: any;
}

const Others: FC<OthersProps> = ({
  handleModalOpen,
  uploadedOtherFileList,
  uploadedFileColumns,
  claimData,
}) => {
  return (
    <>
      <h3>Others</h3>
      <>
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginRight: "2%",
            }}
          >
            <Button
              type="primary"
              style={{
                backgroundColor: "rgb(0, 84, 157)",
                color: "#fff",
                boxShadow: "0px 2px 8px 0px #00000040",
                marginTop: "10px",
              }}
              onClick={() => handleModalOpen("other")}
              disabled={claimData?.submitted}
            >
              Upload document
            </Button>
          </div>
          {
            // props?.uploadedFileList.length > 0 &&
                <Table
                  dataSource={uploadedOtherFileList || []}
                  columns={uploadedFileColumns}
                  pagination={false}
                  className="claim-table"
                  bordered
                  style={{
                    width: "100%",
                    margin: "10px 0",
                    textAlign: "center",
                  }}
                />
          }
        </div>
      </>
    </>
  );
};

export default Others;
